import React, { useContext, useState } from 'react';
import { AuthContext } from '../../auth/AuthContext';
import { useNavigate } from 'react-router-dom';
import { deactivateUser, deleteUser } from '../../lib/allauth';
import { Button, Box, Typography, Card, CardContent } from '@mui/material';
import { styled } from '@mui/system';
import PopoverCard from '../../components/PopoverCard';
import BaseHeader from '../../components/BaseHeader';
import BackgroundContainer from '../../components/BackgroundContainer';
import BaseButton from '../../components/BaseButton';


const DeleteButton = styled(Button)({
  fontFamily: 'Playfair Display, serif',
  color: '#8880a0', // soft gray-violet
  backgroundColor: 'transparent',
  border: '1px solid rgba(255, 191, 229, 0.1)',
  padding: '6px 12px',
  fontSize: '0.85rem',
  borderRadius: '10px',
  boxShadow: 'none',
  textTransform: 'none',
  transition: 'opacity 0.3s ease, background-color 0.3s ease',
  '&:hover': {
    backgroundColor: 'rgba(255, 191, 229, 0.05)',
    opacity: 0.8,
  },
});
const HeyTitle = styled(Typography)({
  fontFamily: 'Playfair Display, serif',
  fontSize: '1.8rem',
  color: '#ffbfe5',
  textAlign: 'center',
  textShadow: '0px 2px 6px rgba(0, 0, 0, 0.5)',
});

const Subtitle = styled(Typography)({
  fontFamily: 'Cormorant Garamond, serif',
  fontSize: '1rem',
  color: '#c2b8c2',
  textAlign: 'center',
  lineHeight: 1.4,
  maxWidth: '80%',
  marginBottom:'20px'
});


const UserProfile = () => {
  const { auth, setAuth } = useContext(AuthContext); // Access auth context
  const [response, setResponse] = useState({ fetching: false, content: null });
  const [deletePopoverOpen, setDeletePopoverOpen] = useState(false)
  const [verifyDeletePopoverOpen, setVerifyDeletePopoverOpen] = useState(false)
  const navigate = useNavigate();

  const handleDelete = () => {
    setResponse({ ...response, fetching: true });

    deleteUser()
      .then((resp) => {
        setResponse((prev) => ({ ...prev, content: resp }));
        if (resp.status === 200) {
          alert('Your account has been successfully deleted.');
          window.location.reload();
        }
      })
      .catch((error) => {
        console.error(error);
        alert('An error occurred while trying to delete your account.');
      })
      .finally(() => {
        setResponse((prev) => ({ ...prev, fetching: false }));
      });
  };

  const handleDeactivate = () => {
    setResponse({ ...response, fetching: true });

    deactivateUser()
      .then((resp) => {
        setResponse((prev) => ({ ...prev, content: resp }));
        if (resp.status === 200) {
          alert('Your account has been successfully deactivated.');
          window.location.reload();
        }
      })
      .catch((error) => {
        console.error(error);
        alert('An error occurred while trying to deactivate your account.');
      })
      .finally(() => {
        setResponse((prev) => ({ ...prev, fetching: false }));
      });
  };

  return (
    <BackgroundContainer sx={{overflowY: 'hidden'}}>
  <BaseHeader sx={{ marginBottom: '2px' }}>Profile</BaseHeader>
  <HeyTitle>
    Hey {auth?.data?.user?.name || 'User'}
  </HeyTitle>
  <Subtitle>
    {/* Your Membership Plan {': ' + (auth?.data?.user?.membership.replace('Plan', '').trim() || 'Free Version')} */}
  </Subtitle>

  <Box display="flex" flexDirection="column" alignItems="center" flexGrow={1} justifyContent="flex-start">
    {/* All your top buttons */}
    {auth?.data?.user?.membership !== "Premium" && (
      <BaseButton style={{ width: '100%' }} onClick={() => navigate('/account/paymentpage')}>
        Upgrade Account
      </BaseButton>
    )}
    <BaseButton style={{ width: '100%' }} onClick={() => navigate('/account/password/change')}>
      Change Password
    </BaseButton>
    {!auth?.data?.user?.email_verified && (
      <BaseButton style={{ width: '100%' }} onClick={() => navigate('/account/email')}>
        Verify/Change Email
      </BaseButton>
    )}
    <BaseButton style={{ width: '100%' }} onClick={() => navigate('/')}>
      Back
    </BaseButton>
  </Box>

  {/* Now the DeleteButton separately at the bottom */}
  <Box display="flex" justifyContent="center" sx={{ marginTop: 'auto', marginBottom: '20px' }}>
    <DeleteButton sx={{marginTop: '30px'}} onClick={() => setDeletePopoverOpen(true)}>
      Delete Account
    </DeleteButton>
  </Box>

  {/* Popovers */}
  <PopoverCard
    mainText={'This action will delete your account'}
    open={deletePopoverOpen}
    onClose={() => setDeletePopoverOpen(false)}
    showButtonOne={true}
    textButtonOne={'DELETE account'}
    onButtonOne={() => setVerifyDeletePopoverOpen(true)}
  />
  <PopoverCard
    mainText={'Are you sure you want to delete the account? Any payment plan you might have will be lost.'}
    open={verifyDeletePopoverOpen}
    onClose={() => setVerifyDeletePopoverOpen(false)}
    showButtonOne={true}
    textButtonOne={'Yes, DELETE account permanently'}
    onButtonOne={handleDeactivate}
  />
</BackgroundContainer>

  );
};

export default UserProfile;
